import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const AdminAlumniModal = ({ show, onClose, onSubmit, alumni }) => {

  const [formData, setFormData] = useState({
    name: "",
    year: "",
    about: "",
    image: null
  });

  useEffect(() => {
    if(alumni){
      setFormData({
        name: alumni.name,
        year: alumni.year,
        about: alumni.about,
        image: null
      });
    } else {
      setFormData({
        name: "",
        year: "",
        about: "",
        image: null
      });
    }
  }, [alumni]);

  const handleChange = (e)=>{
    setFormData({...formData,[e.target.name]:e.target.value});
  }

  const handleFile = (e)=>{
    setFormData({...formData,image:e.target.files[0]});
  }

  const handleSubmit = (e)=>{
    e.preventDefault();
    onSubmit(formData);
  }

  return (
    <Modal show={show} onHide={onClose} centered>    
        <Modal.Header>
        <Modal.Title>{alumni ? "Edit Alumni" : "Add Alumni"}</Modal.Title>
            <button
              type="button"
              className="btn btn-secondary ms-auto"
              onClick={onClose}
            >Close</button>
        </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          
          <Form.Group className="mb-2">
            <Form.Control
              type="text"
              name="name"
              placeholder="Alumni Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Control
              type="number"
              name="year"
              placeholder="Batch Year"
              value={formData.year}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-2" >
            <Form.Control
              style={{ width: "400px", height: "150px"}}
              as="textarea"
              name="about"
              placeholder="About Alumni"
              value={formData.about}
              onChange={handleChange}
              rows={3}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Control
              type="file"
              onChange={handleFile}
            />
          </Form.Group>

          <Button type="submit" variant="primary" className="w-100">
            {alumni ? "Update Alumni" : "Add Alumni"}
          </Button>

        </Form>
      </Modal.Body>

      {/* ✅ Added Footer Close Button */}
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>

    </Modal>
  )
}

export default AdminAlumniModal;